import { useSelector } from 'react-redux';

import { IReduxState } from '../../types/redux';

export const selectSpecialTabActive = (state: IReduxState) => state.specialTabs.specialTabActive;

export const useSpecialTabActive = () => useSelector(selectSpecialTabActive);
